export default "__VITE_ASSET__D_ciagq4__"